import React from "react";
import axios from "axios";
import BaseUrl from "../../ApiServices/BaseUrl";
import loadRazorpay from "../../ApiServices/loadRazorpay";

const PayNow = () => {
  const handlePayment = async () => {
    try {
      // 1️⃣ Call backend to create order
      const { data } = await axios.post(`${BaseUrl}/api/orders`, {
        amount: 50000, // 500 INR
        currency: "INR",
      });

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY,
        amount: data.amount,
        currency: data.currency,
        name: "My Store",
        description: "Test Transaction",
        order_id: data.order_id,
        handler: async function (response) {
          try {
            // 2️⃣ Send response to backend for verification
            const verifyRes = await axios.post(`${BaseUrl}/api/verify-payment`, {
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
            });

            if (verifyRes.data.success) {
              alert("✅ Payment Verified & Successful!");
            } else {
              alert("❌ Payment Verification Failed!");
            }
          } catch (error) {
            console.error("Verification error:", error);
            alert("❌ Verification request failed");
          }
        },
        prefill: {
          name: "John Doe",
          email: "johndoe@example.com",
          contact: "9876543210",
        },
        theme: { color: "#3399cc" },
      };

      const isRazorpayReady = await loadRazorpay();
      if (!isRazorpayReady) {
        alert("Payment gateway failed to load. Please try again.");
        return;
      }
      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (err) {
      console.error("Payment error:", err);
    }
  };

  return (
    <div>
      <h2>Pay with Razorpay</h2>
      <button onClick={handlePayment}>Pay ₹500</button>
    </div>
  );
};

export default PayNow;
